"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vuetify_1 = __importDefault(require("vuetify"));
require("vuetify/dist/vuetify.min.css");
require("@mdi/font/css/materialdesignicons.css");
var opts = {
    icons: {
        iconfont: 'mdi'
    }
};
exports.default = new vuetify_1.default(opts);
